export const SUBMIT = 'CHANGE_PASSWORD/SUBMIT'
